{
	"header": {
		"tag": "Ylläpito",
		"title": "Katalogi"
	},
	"notAuthorized": "Ei oikeuksia.",
	"maintenance": {
		"title": "Ylläpito",
		"backfill": "Päivitä hakuteksti",
		"running": "Käynnissä…",
		"description": "Täyttää searchText-kentän ilmoituksille, jotka on luotu ennen kentän lisäämistä.",
		"success": "Hakuteksti päivitetty {{count}} ilmoitukselle",
		"error": "Päivitys epäonnistui"
	},
	"tabs": {
		"manufacturers": "Valmistajat",
		"discModels": "Kiekkomallit",
		"plastics": "Muovit",
		"reports": "Raportit",
		"resolved": "Ratkaistu",
		"feedback": "Palaute",
		"catalogue": "Katalogi"
	},
	"common": {
		"save": "Tallenna",
		"saving": "Tallennetaan…",
		"cancel": "Peruuta",
		"edit": "Muokkaa",
		"custom": "Mukautettu",
		"selectManufacturer": "Valitse valmistaja",
		"selectClass": "Valitse luokka",
		"customEntry": "Mukautettu merkintä"
	},
	"manufacturers": {
		"new": "Uusi valmistaja",
		"edit": "Muokkaa valmistajaa",
		"count_one": "{{count}} valmistaja",
		"count_other": "{{count}} valmistajaa",
		"name": "Nimi",
		"namePlaceholder": "esim. Innova",
		"updated": "Valmistaja päivitetty",
		"created": "Valmistaja luotu"
	},
	"discModels": {
		"new": "Uusi malli",
		"showing": "{{filtered}} / {{total}}",
		"searchPlaceholder": "Hae mallilla tai valmistajalla…",
		"editTitle": "Muokkaa kiekkomallia",
		"newTitle": "Uusi kiekkomalli",
		"manufacturer": "Valmistaja",
		"model": "Malli",
		"modelName": "Mallin nimi",
		"modelPlaceholder": "esim. Destroyer",
		"class": "Luokka",
		"identity": "Identiteetti",
		"flight": "Lennot",
		"officialFlight": "Viralliset lentonumerot",
		"speed": "Speed",
		"glide": "Glide",
		"turn": "Turn",
		"fade": "Fade",
		"stability": "Vakaus",
		"stabilityPlaceholder": "esim. overstable",
		"physicalSpecs": "Fyysiset mitat",
		"maxWeight": "Max paino (g)",
		"diameter": "Halkaisija (cm)",
		"height": "Korkeus (cm)",
		"rimDepth": "Vanteen syvyys (cm)",
		"insideRimDia": "Vanteen sisähalkaisija (cm)",
		"rimThickness": "Vanteen paksuus (cm)",
		"rimDDRatio": "Vanne D/D -suhde",
		"rimConfig": "Vanteen muoto",
		"flexibility": "Joustavuus",
		"certification": "Sertifiointinumero",
		"updated": "Kiekkomalli päivitetty",
		"created": "Kiekkomalli luotu"
	},
	"plastics": {
		"new": "Uusi muovi",
		"count_one": "{{count}} muovi",
		"count_other": "{{count}} muovia",
		"editTitle": "Muokkaa muovia",
		"newTitle": "Uusi muovi",
		"manufacturer": "Valmistaja",
		"name": "Nimi",
		"namePlaceholder": "esim. Star",
		"ratings": "Arviot",
		"durability": "Kestävyys",
		"stability": "Vakaus",
		"flexibility": "Joustavuus",
		"categoryMetadata": "Kategorian tiedot",
		"categoryName": "Kategorian nimi",
		"categoryDurability": "Kestävyys",
		"categoryBreakIn": "Sisäänajo",
		"categoryStabilityChange": "Vakausmuutos",
		"categoryColors": "Värit",
		"categoryFirmness": "Kovuus",
		"updated": "Muovi päivitetty",
		"created": "Muovi luotu"
	},
	"reports": {
		"open_one": "{{count}} avoin raportti",
		"open_other": "{{count}} avointa raporttia",
		"resolved_one": "Ratkaistu ({{count}})",
		"resolved_other": "Ratkaistu ({{count}})",
		"listing": "Ilmoitus",
		"reason": "Syy",
		"note": "Huomio",
		"reporter": "Ilmoittaja",
		"reported": "Ilmoitettu",
		"noOpen": "Ei avoimia raportteja.",
		"dismiss": "Hylkää",
		"removeListing": "Poista ilmoitus",
		"dismissed": "Raportti hylätty.",
		"listingRemoved": "Ilmoitus poistettu.",
		"resolveFailed": "Raportin käsittely epäonnistui.",
		"resolution": "Ratkaisu",
		"reviewedAt": "Tarkistettu",
		"removed": "Poistettu",
		"dismissedLabel": "Hylätty"
	},
	"feedback": {
		"open_one": "{{count}} avoin raportti",
		"open_other": "{{count}} avointa raporttia",
		"resolvedSection_one": "Ratkaistu ({{count}})",
		"resolvedSection_other": "Ratkaistu ({{count}})",
		"type": "Tyyppi",
		"typeBug": "Bugi",
		"typeFeedback": "Palaute",
		"description": "Kuvaus",
		"page": "Sivu",
		"reporter": "Lähettäjä",
		"submitted": "Lähetetty",
		"resolvedAt": "Ratkaistu",
		"anonymous": "Anonyymi",
		"noOpen": "Ei avointa palautetta.",
		"resolve": "Merkitse ratkaistuksi",
		"delete": "Poista",
		"resolved": "Palaute merkitty ratkaistuksi.",
		"resolveFailed": "Käsittely epäonnistui.",
		"deleted": "Raportti poistettu.",
		"deleteFailed": "Poisto epäonnistui."
	},
	"reasons": {
		"spam": "Roskaposti",
		"misleadingDescription": "Harhaanjohtava kuvaus",
		"inappropriateImage": "Sopimaton kuva",
		"wrongDisc": "Väärä kiekko",
		"other": "Muu"
	}
}
